import Reveal from './ui/Reveal';
import RichText from './ui/RichText';
import { faqs } from '../data/content';

export default function Faq() {
  return (
    <section id="faq">
      <div className="wrap">
        <Reveal as="h2" className="h-sec center">
          Frequently asked questions
        </Reveal>

        <Reveal className="faq mt-l" delay={1}>
          {faqs.map((item) => (
            <details key={item.q} open={item.defaultOpen}>
              <summary>
                {item.q}
                <span className="plus" aria-hidden="true">
                  +
                </span>
              </summary>
              <div className="body">
                {item.a.map((paragraph, i) => (
                  <p key={i}>
                    <RichText text={paragraph} />
                  </p>
                ))}
              </div>
            </details>
          ))}
        </Reveal>
      </div>
    </section>
  );
}
